import "../extensions/object";
import "../extensions/htmlelement";
import "../extensions/string";
import { AjaxRequest, AjaxMethod } from "./ajax";
import Swiper from "swiper";
export class Lightbox {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.close = function () {
            let box = window.document.querySelector(".modal");
            let backdrop = window.document.querySelector(".modal-backdrop");
            if (box) {
                box.remove();
                backdrop.remove();
                window.document.querySelector(".modal");
                if (this.options.disableScrollOnOpen)
                    this.enableScroll();
                this.options.onClose();
            }
        };
        this.options = Object.merge(this.options, options);
        this.options.onClose = (_a = this.options.onClose) !== null && _a !== void 0 ? _a : function () { };
        this.options.onLoaded = (_b = this.options.onLoaded) !== null && _b !== void 0 ? _b : function () { };
        this.options.onOpen = (_c = this.options.onOpen) !== null && _c !== void 0 ? _c : function () { };
        this.options.onResize = (_d = this.options.onResize) !== null && _d !== void 0 ? _d : function () { };
        this.options.width = (_e = this.options.width) !== null && _e !== void 0 ? _e : 640;
        this.options.height = (_f = this.options.height) !== null && _f !== void 0 ? _f : 480;
        this.options.allowFullscreen = (_g = this.options.allowFullscreen) !== null && _g !== void 0 ? _g : false;
        this.options.disableScrollOnOpen = (_h = this.options.disableScrollOnOpen) !== null && _h !== void 0 ? _h : true;
    }
    getHtml() {
        let box = window.document.querySelector(".modal");
        if (box) {
            this.close();
        }
        let output = "";
        output = "<div class='modal show'>";
        output += '<div class="navigation">';
        if (this.options.allowFullscreen) {
            output += '<span class="fullscreen-modal"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="expand" class=" svg-inline--fa fa-expand fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"></path></svg></span>';
        }
        output += '<span class="close-modal"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" class=" svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"><path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg></span>';
        output += '</div>';
        output += "<div class='modal-dialog modal-dialog-centered'>";
        output += "<div class='modal-content'>";
        output += "<div class='modal-body'></div>";
        output += "</div>";
        output += "</div>";
        output += "</div>";
        var div = document.createElement('div');
        div.innerHTML = output.trim();
        return div.firstChild;
    }
    getIframeContent(href) {
        let youtubeExpression = new RegExp("youtu(\.be/|be\.com.+?v=)(.+)", "ig");
        let vimeoExpression = new RegExp("vimeo.com/(.+)", "ig");
        let matchYoutube = youtubeExpression.exec(href);
        let matchVimeo = vimeoExpression.exec(href);
        let iframe = document.createElement('iframe');
        iframe.width = this.options.width.toString();
        iframe.height = this.options.height.toString();
        iframe.frameBorder = "0";
        if (matchYoutube) {
            let id = matchYoutube[2];
            iframe.src = "https://www.youtube.com/embed/" + id;
            iframe.allowFullscreen = true;
            return iframe;
        }
        else if (matchVimeo != null) {
            let id = matchVimeo[1];
            iframe.src = "https://player.vimeo.com/video/" + id;
            iframe.allowFullscreen = true;
            return iframe;
        }
        iframe.src = href;
        return iframe;
    }
    show(input) {
        var _a, _b;
        const box = this.getHtml();
        const dialog = box.querySelector(".modal-dialog");
        const backdrop = document.createElement('div');
        backdrop.addClass("modal-backdrop");
        box.querySelector(".modal-body").append(input);
        (_a = box.querySelector(".close-modal")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", () => {
            this.close();
        });
        (_b = box.querySelector(".fullscreen-modal")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", () => {
            if (box.hasClass("modal-fullscreen"))
                box.removeClass("modal-fullscreen");
            else
                box.addClass("modal-fullscreen");
            this.options.onResize();
            this.slideshow();
        });
        box.addEventListener("click", (e) => {
            const target = e.target;
            try {
                if (target != null && target.hasClass("modal"))
                    this.close();
            }
            catch (_a) { }
        });
        window.document.body.prepend(box);
        window.document.body.append(backdrop);
        box.addStyle("display", "block");
        box.addClass("show");
        backdrop.addClass("show");
        if (this.options.width >= 1140) {
            dialog.addClass("modal-xl");
        }
        else if (this.options.width >= 800) {
            dialog.addClass("modal-lg");
        }
        else if (this.options.width >= 500) {
            dialog.addClass("modal-md");
        }
        else if (this.options.width <= 300) {
            dialog.addClass("modal-sm");
        }
        this.resizeIframe();
        this.slideshow();
        this.options.onLoaded(input);
    }
    slideshow() {
        let swiperContainer = window.document.querySelector(".modal .swiper-container");
        if (swiperContainer === null) {
            return;
        }
        if (this.swiper) {
            this.swiper.destroy(true, true);
        }
        window["picturefill"]();
        this.swiper = new Swiper('.modal .swiper-container', {
            direction: 'horizontal',
            watchOverflow: true,
            loop: true,
            lazy: false,
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.swiper-scrollbar',
            },
        });
    }
    open() {
        if (this.options.disableScrollOnOpen)
            this.disableScroll();
        this.options.onOpen();
        if (this.options.type == LightboxType.DIV) {
            let content = window.document.querySelector(this.options.target);
            if (content) {
                content = content.cloneNode(true);
                content.removeAttribute("id");
                content.visible(true);
                this.show(content);
            }
        }
        else if (this.options.type == LightboxType.AJAX) {
            if (this.options.href.length > 0) {
                let ajax = new AjaxRequest();
                ajax.Send(AjaxMethod.GET, this.options.href, {}).then((results) => {
                    this.show(results.data.toHTML());
                }, (error) => {
                    console.log(error);
                });
            }
        }
        else {
            if (this.options.href.length > 0) {
                let content = this.getIframeContent(this.options.href);
                this.show(content);
            }
        }
    }
    resizeIframe() {
        let box = window.document.querySelector(".modal");
        let iframe = box.querySelector("iframe");
        if (iframe != null) {
            console.log(iframe.clientWidth);
            var percent = this.options.height / this.options.width;
            iframe.setAttribute("height", (iframe.clientWidth * percent).toString());
        }
    }
    disableScroll() {
        let body = document.querySelector("body");
        if (!body)
            return;
        body.addClass("modal-open");
        //body.addStyles({ "overflow": "hidden" });
    }
    enableScroll() {
        let body = document.querySelector("body");
        if (!body)
            return;
        body.removeClass("modal-open");
    }
}
export var LightboxType;
(function (LightboxType) {
    LightboxType["IFRAME"] = "iframe";
    LightboxType["AJAX"] = "ajax";
    LightboxType["DIV"] = "div";
})(LightboxType || (LightboxType = {}));
HTMLElement.prototype.lightBox = function (options) {
    options = options != null ? options : {};
    options.type = options.type != null ? options.type : this.getAttribute("data-type");
    options.href = options.href != null ? options.href : this.getAttribute("href");
    options.target = options.target != null ? options.target : this.getAttribute("data-target");
    let box = new Lightbox(options);
    this.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        box.open();
    });
    return this;
};
